// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"lighthouse"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6 22C6 22 8 15 8 10V3H16V10C16 15 18 22 18 22H14L13 18H11L10 22H6Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 2V10C8 15 6 22 6 22H10L11 18H13L14 22H18C18 22 16 15 16 10V2M16 6H8M8 3H16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 9.99805H12.0039V10.002H12V9.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LighthouseIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lighthouse',
    ref,
    icon: element,
  },
));

LighthouseIcon.displayName = 'LighthouseIcon';

export default LighthouseIcon;
